import types from './types'

const INITIAL_STATE = {
    selected_account: null,
    accounts: [],
    accounts_loading: false,
    accounts_error: null,
}

const accountSelectionReducers = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case types.GET_ACCOUNTS_REQUEST: 
            return {
                ...state,
                accounts_loading: true,
                accounts_error: null
            }
        case types.GET_ACCOUNTS_SUCCESS:
            return {
                ...state,
                accounts: action.payload.accounts,
                accounts_loading: false,
                accounts_error: null
            }
        case types.GET_ACCOUNTS_ERROR: 
            return {
                ...state,
                accounts_loading: false,
                accounts_error: action.payload.err
            }
        case types.SELECT_ACCOUNT:
            return {
                ...state,
                selected_account: action.payload.uid
            }
        case types.CLEAR_ACCOUNTS: {
            return INITIAL_STATE
        }
        
        default:
            return state
    }
}

export default accountSelectionReducers 